import ApiLokalni from "../../ApiLokalni.ts";
import axios from "axios";


export interface GoodArticle {
    goodId: number;
    shortDescription: string;
    description: string;
    image:string;
    epid:string;
}

export interface Article {
    article: GoodArticle;
}


class LocalNewsApi extends ApiLokalni {

    public constructor(token : string) {
        super(token);
    }

    public async article() : Promise<GoodArticle> {

        const url = this.getUrl() + '/api/v1/promotion/good';

        try {
            const response = await axios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            return response.data;
        } catch (error) {
            console.log(error);
        }

        return {
                goodId: 0, epid: '', shortDescription: '', description: '', image: ''
        };
    }

}

export default LocalNewsApi;